namespace Core {

    class FareRulesLink {
        text:string;
        details:string;

        constructor(private modalService:any) {
        }

        showFareRules () {
            const fareRulesText = this.details || '';
            if(fareRulesText){
                this.modalService.launch('partials/popups/farerules', { fareRulesText });
            }
        };
    }
    angular
        .module('TR')
        .directive('fareRulesLink', function(modalService) {
            return {
                restrict: 'E',
                bindToController: {
                    text: '@',
                    details: '='
                },
                controllerAs: 'fr',
                controller: FareRulesLink,
                template: '<div><a href="#" ng-click="fr.showFareRules()">{{fr.text}}</a></div>'
            };
        });
}
